
import styled from 'styled-components'

const pageWidth = props => props.theme.global.size.pageWidth;
const backgroundWhite = props => props.theme.global.colors['white'];
const borderColor = props => props.theme.global.colors['light-4']; //#CCCACA
const lightBorderColor = props => props.theme.global.colors['light-7']; //#D4D4D6
const backgroundBackColor = props => props.theme.global.colors['background-back']; //#F4F4F4
const tabletBreakpoints = props => props.theme.mediaQuery.up('tablet-landscape');

export const LRContainerWmo = styled.div`
  max-width: ${pageWidth};
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  margin: 0 auto;
  
  ${tabletBreakpoints}{
    padding: 32px 40px;
  }
`

export const Heading2= styled.h2`
    font-size: 20px;
    font-weight: 500;
    line-height: 30px;
    margin: 0 0 16px;

    ${tabletBreakpoints}{
        font-size: 24px; 
        line-height: 36px;
        margin: 0 0 24px;
    }
`

export const Heading4 = styled.h4`
    font-size: 16px;
    font-weight: 600;
    line-height: 26.4px;
    margin: 0px;
    padding-bottom: 8px;

    ${tabletBreakpoints}{
        font-size: 20px;
        line-height: 30px;
    }
`


export const ItemDetailsWrapper = styled.div`
    background: ${backgroundWhite};
    border: 1px solid ${borderColor};
    border-radius: 6px;
    padding: 16px;  

    ${tabletBreakpoints}{
        padding: 24px;  
    }
`

export const OrderDateDetails = styled.div`
    display: flex;
    flex-direction: column;
    line-height: 165%;
    gap: 8px;
    font-size: 16px;
    color: #3E3E47;
    font-weight: 700;
    padding-bottom: 16px;
    
    .key{
        font-weight: 400;
    }

    .separator{
        color: #939398;
    }

    ${tabletBreakpoints}{
        flex-direction: row;
        gap: 5px;
        padding-bottom: 24px;
    }
`

export const ItemDetailWrapper = styled.div`
    display: flex;
    border: 1px solid ${lightBorderColor};
    border-radius: 4px;
    padding: 16px;
    gap: 8px;
    font-size: 14px;
    line-height: 165%;

    ${tabletBreakpoints}{
        padding: 24px;
        font-size: 16px;
        gap: 32px;
    }
`

export const ItemDetail = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    .itemTotal{
        font-weight: 600;
        font-size: 14px;
        line-height: 23.1px;
    }

    ${tabletBreakpoints}{
        gap: 16px;

        .itemTotal{
            font-size: 16px;
            line-height: 26.4px;
        }
    }
`

export const LRRefund = styled.div`
    padding: 16px 0px;
    font-size: 20px;
    font-weight: 600;
    line-height: 150%;

    ${tabletBreakpoints}{
        padding: 24px 0px;
    }
`

export const BrandName = styled.span`
    font-weight: 600;
`

export const ReturnItemDetail = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 12px;
    line-height: 19.8px;
`

export const QuantitySelectionWrapper = styled.div`
    width: 120px;
    height: 48px;
    >button {
        height:100%
    }
`

export const ImageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
`

export const ConfirmQty = styled.div`
    background: ${backgroundBackColor};
    width: 100%;
    text-align: center;
    border-radius: 4px;
    padding: 4px;
    font-size: 14px;
    font-weight: 600;
    line-height: 23.1px;
`

export const ImageContainer = styled.div`
    flex-shrink: 0;
    max-width: 88px;
    max-height: 88px;

    ${tabletBreakpoints}{
        max-width: 108px;
        max-height: 108px;
    }
`